import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: 'border-box',
    '& ul': {
      margin: 0,
      padding: 0,
    },
  },
  noUsage: {
    padding: theme.spacing(2),
  },
  title: {
    fontSize: 16,
    color: '#1d4065',
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
  },
  copyIcon: {
    height: 10,
    width: 10,
    fontSize: 15,
    marginInlineStart: theme.spacing(1),
  },
  list: {
    border: `1px solid #e5e6e7`,
    borderRadius: 5,
    margin: 0,
  },
  amountPaid: {
    margin: '0 16px',
    color: '#1879fa',
    cursor: 'pointer',
    marginRight: '4px',
  },
  info: {

    borderRadius: 4,
    padding: theme.spacing(1.5),
  },
  detail: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
    marginBottom: theme.spacing(1),
  },
  detailValue: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
  },
  titleBox: {
    background: '#eef1f5',
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    boxSizing: 'border-box',
    marginBottom: 0,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  titleArrow: {
    color: '#b9c3ca',
    fontSize: 20,
  },
  tableCell: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    borderBottom: '1px solid rgba(109,114,120,0.2)',
  },
  table: {
    marginTop: theme.spacing(2),
    border: '1px solid rgba(109,114,120,0.18)',
    borderRadius: 4,
  },
  tableHeader: {
    background: '#eef1f5',
  },
  tableDataCell: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
}));
